//TODO Disable hvis udsolgt

import angular from 'angular';

angular.module('folkeuni').component('accessories', {
  bindings: {
    accessorieSumup: '=',
    currentOrderline: '=',
    product: '<'
  },
  templateUrl: '/shop-dist/templates/accessories.html?c=' + window.cacheBurst,
  transclude: false,
  controller: function ($log) {
    var $ctrl = this;
    $ctrl.currentTicket = null;
    $ctrl.currentTicketLocationInArray = 0;
    $ctrl.options = [];


    function activateTicket() {
      if ($ctrl.currentTicket) {
        $ctrl.currentTicket.active = false;
      }
      $ctrl.currentTicket = $ctrl.currentOrderline.tickets[$ctrl.currentTicketLocationInArray];
      $ctrl.currentTicket.active = true;
        //Løb alle priser igennem, tjek om bruger har benyttet voucher og sæt display price
        for (var i = 0; $ctrl.options.length > i; i++) {
          var currentOptionGroup = $ctrl.options[i];
         
          for(var y = 0; currentOptionGroup.items.length > y;y++){
            var currentOptionGroupItem = currentOptionGroup.items[y];
            for(var x = 0; currentOptionGroupItem.prices.length > x;x++){
              var currentOptionGroupItemPrice = currentOptionGroupItem.prices[x]; 

              if($ctrl.currentTicket.type == "KeyAccount" && currentOptionGroupItemPrice.type == "KeyAccount"){                
                currentOptionGroupItem.displayPrice = currentOptionGroupItemPrice.value;
                break;
              }else {
                  currentOptionGroupItem.displayPrice = currentOptionGroupItemPrice.value;
              }
            }
          }             
      }

      if ($ctrl.currentTicket.accessories) {

        for (var i = 0; $ctrl.currentTicket.accessories.length > i; i++) {
          var currentTicketOptions = $ctrl.currentTicket.accessories[i];

          for (var y = 0; $ctrl.options.length > y; y++) {
            var currentOptionGroup = $ctrl.options[y];

            if (currentTicketOptions.optionGroup == currentOptionGroup.id) {
              if (currentOptionGroup.required) {
                currentOptionGroup.selected = currentTicketOptions.id;
            } else {
              for (var x = 0; currentOptionGroup.items.length > x; x++) {
                  var currentOption = currentOptionGroup.items[x];

                  if (currentOption.id == currentTicketOptions.id) {
                    currentOption.selected = true;
                  }
                }
              }
            }
          }
        }
      }
    }

    function dynamicSort(property) {
      var sortOrder = 1;
      if(property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
      }
      return function (a,b) {
          var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
      }
  }

    $ctrl.$onInit = function () {
      $ctrl.product.options.sort(dynamicSort("id"));
      $ctrl.options = $ctrl.product.options;
      for (var i = 0; $ctrl.options.length > i; i++) {
        var currentOptionGroup = $ctrl.options[i];
        if (currentOptionGroup.required && !currentOptionGroup.selected) {
          currentOptionGroup.selected = Number(currentOptionGroup.items[0].id);
        }
      }

      $ctrl.updateAccessorieQuanties();
      activateTicket();
    };

    $ctrl.updateAccessorieQuanties = function () {

      $ctrl.accessorieSumup = [];

      for (var z = 0; $ctrl.currentOrderline.tickets.length > z; z++) {
        var currentOrderlineTicket = $ctrl.currentOrderline.tickets[z];

        for (var y = 0; currentOrderlineTicket.accessories.length > y; y++) {
          var currentAccessory = currentOrderlineTicket.accessories[y];
          var matched = false;

          for (var i = 0; $ctrl.accessorieSumup.length > i; i++) {
            var currentSumpupAccessory = $ctrl.accessorieSumup[i];

            if (currentSumpupAccessory.id == currentAccessory.id) {
              currentSumpupAccessory.quantity++;
              matched = true;
              break;
            }
          }

          if (!matched) {
            const accessorieCopy = angular.copy(currentAccessory);
            accessorieCopy.quantity = 1;
            $ctrl.accessorieSumup.push(accessorieCopy);
          }
        }

      }
    }

    $ctrl.resetTempAccessories = function () {
      for (var i = 0; $ctrl.options.length > i; i++) {
        var currentOptionGroup = $ctrl.options[i];

        if (currentOptionGroup.required) {
          currentOptionGroup.selected = Number(currentOptionGroup.items[0].id);
        } else {
          for (var y = 0; currentOptionGroup.items.length > y; y++) {
            var currentOption = currentOptionGroup.items[y];
            currentOption.selected = false;
          }
        }
      }

    }

    $ctrl.stepBack = function () {
      $ctrl.currentOrderline.step = 0;
    }

    $ctrl.stepPrevAccessories = function () {
      $ctrl.updateAccessorieQuanties();
      $ctrl.currentTicketLocationInArray--;
      $ctrl.resetTempAccessories();
      activateTicket();

      $ctrl.statusBarLength();
    }

    function pushCurrentOptionToTicketArray() {
      var currentOptionGroups = angular.copy($ctrl.options);

      $ctrl.currentTicket.accessories = [];

      for (var i = 0; currentOptionGroups.length > i; i++) {
        var currentOptionGroup = currentOptionGroups[i];

        if (currentOptionGroup.required) {
          if (currentOptionGroup.selected) {
            for (var o = 0; currentOptionGroup.items.length > o; o++) {
              var currentOption = currentOptionGroup.items[o];
              if (currentOptionGroup.selected == currentOption.id) {
                currentOption.optionGroup = currentOptionGroup.id;
                $ctrl.currentTicket.accessories.push(currentOption);
              }
            }
          }
        } else {
          for (var o = 0; currentOptionGroup.items.length > o; o++) {
            var currentOption = currentOptionGroup.items[o];
            if (currentOption.selected) {
              currentOption.optionGroup = currentOptionGroup.id;
              $ctrl.currentTicket.accessories.push(currentOption);
            }
          }
        }
      }

    }

    $ctrl.finishAndOrder = function () {

      pushCurrentOptionToTicketArray();
      $ctrl.currentOrderline.addToCart();

    }
    $ctrl.stepNextAccessories = function () {
      pushCurrentOptionToTicketArray();

      $ctrl.updateAccessorieQuanties();

      $ctrl.currentTicketLocationInArray++;

      $ctrl.statusBarLength();

      if ($ctrl.currentTicketLocationInArray == $ctrl.currentOrderline.tickets.length) {

      } else {
        $ctrl.resetTempAccessories()
        activateTicket();
      }
    }

    //status bar
    $ctrl.statusBarLength = function () {
      $ctrl.newStatusLength = ($ctrl.currentTicketLocationInArray + 1) / $ctrl.currentOrderline.tickets.length * 100 + '%';
    }


    // hvis currentTicketLocationInArray bliver < 0 så skal du til ticket-komponent
    // Radiobutton
    // Samme for alle billetter.
  }
});